import React from 'react';
import ListItem from './ListItem';

const isItemContainImage = filterList => {
  return filterList === 'frame_shape_id' || filterList === 'frametype_id';
};
// frame_size_id removed from isItemContainImage on request by product
const checkImage = (param, props) => {
  const { filterList } = props;
  let imgPath;
  if (isItemContainImage(filterList)) {
    if (window.location.href?.indexOf('sunglasses') !== -1) {
      imgPath = `https://static.lenskart.com/images/cust_mailer/Sunglass/${param.replace(
        /\s/g,
        ''
      )}.png`;
    } else {
      imgPath = `https://static.lenskart.com/images/cust_mailer/Eyeglass/${param.replace(
        /\s/g,
        ''
      )}.png`;
    }
    return imgPath;
  }
};

const List = props => {
  const {
    data,
    count,
    filterList,
    isPrimaryFilter,
    handleFunc,
    userFrameSize,
    dataLocale: { RECOMMENDED },
  } = props;
  let { checkedOptions } = props;
  let displayData = '';
  if (count === 0) {
    displayData = (
      <ListItem
        changeHandler={() => {
          checkedOptions = !checkedOptions;
        }}
        checkedOptions={checkedOptions}
        className={isItemContainImage(filterList) ? 'list-image' : null}
        clickHandler={() => {
          window.scrollTo(0, 0);
          handleFunc(data.title, data.id);
        }}
        style={{ opacity: '.5', color: '#858282', zIndex: '-2' }}
      >
        <span>{`${data.title}(${data.no_of_products})`}</span>
      </ListItem>
    );
  } else {
    displayData = (
      <ListItem
        changeHandler={() => {
          checkedOptions = !checkedOptions;
        }}
        checkedOptions={checkedOptions}
        className={isItemContainImage(filterList) ? 'list-image' : 'list-checkbox'}
        clickHandler={() => {
          window.scrollTo(0, 0);
          handleFunc(data.title, data.id);
        }}
        style={{}}
      >
        {isItemContainImage(filterList) ? (
          <span title={data.title}>
            <img
              alt={data.title}
              className="innerImg"
              data-title={data.id}
              src={checkImage(data.title, props)}
            />
            {isPrimaryFilter && data.title !== undefined && data.title?.indexOf('Kids') === -1 && (
              <span>{data.title}</span>
            )}
          </span>
        ) : (
          <React.Fragment>
            <span>{`${data.title}(${data.no_of_products})`}</span>
            {data.title &&
            userFrameSize &&
            data.title.replace(' ', '').toLowerCase() === userFrameSize.toLowerCase() ? (
              <p className="padding-l5 text-color-orange margin-b0 text-capitalize">
                {RECOMMENDED}
              </p>
            ) : (
              ''
            )}
          </React.Fragment>
        )}
      </ListItem>
    );
  }
  return displayData;
};

export default List;
